import { useMemo, useState } from 'react';
import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import PlaylistAssignmentsPortalProgress from './PlaylistAssignmentsPortalProgress';
import { useFilteredPlaylistAssignmentsPortals } from '../playlistAssignmentsHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TABLE_PAGINATOR_SIZE, AcademyTable } from '../../table';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import UsersAvatarList from '../../avatar/components/UsersAvatarList';
import formatName from 'I18n/utils/formatName';
import { Text } from 'foundations-components/components/Text';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsPortalsTableHeader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.account"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.domain"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.members"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.columns.users"
      })
    })]
  });
};
const PlaylistAssignmentsPortalsTableRow = portal => {
  const {
    playlistId,
    portal: {
      id: portalId,
      domain: portalDomain
    },
    assignees
  } = portal;
  const playlistAssignmentsUrl = `/academy/${PortalIdParser.get()}${getPlaylistAssignmentsUrl(playlistId, portalId)}#playlist-assignments`;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalProgress, {
        portal: portal
      })
    }), /*#__PURE__*/_jsxs("td", {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: portalDomain
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        children: portalId
      })]
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        children: assignees.length
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UsersAvatarList, {
        hasMoreHref: playlistAssignmentsUrl,
        users: assignees.map(({
          firstName,
          lastName,
          userId,
          avatarHash
        }) => {
          return {
            displayName: formatName({
              firstName,
              lastName
            }),
            userId,
            avatarHash
          };
        })
      })
    })]
  });
};
const PlaylistAssignmentsPortalsTable = ({
  playlistId
}) => {
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    pageCount
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    page
  });
  const rows = useMemo(() => {
    const portalsRecord = new Map();
    if (playlistAssignmentsPortals) playlistAssignmentsPortals.forEach(portal => {
      portalsRecord.set(portal.portal.id.toString(), portal);
    });
    return portalsRecord;
  }, [playlistAssignmentsPortals]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AcademyTable, {
      renderHeader: () => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableHeader, {}),
      renderRow: data => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTableRow, Object.assign({}, data)),
      rows: rows
    }), pageCount > 1 && /*#__PURE__*/_jsx(Paginator, {
      maxVisiblePageButtons: TABLE_PAGINATOR_SIZE,
      onPageChange: ({
        target: {
          value
        }
      }) => setPage(value),
      page: page,
      pageCount: pageCount
    })]
  });
};
export default PlaylistAssignmentsPortalsTable;